
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/publicaciones.vue';
    import movil from './movil/publicaciones.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
